/** Leitura/escrita por caminho com pontos (ex.: `fontes.lista.0.nome`). */

export type DraftData = Record<string, unknown>;

export function getPath(source: DraftData, path: string): unknown {
  return path
    .split('.')
    .reduce<unknown>((node, key) => (node as Record<string, unknown> | undefined)?.[key], source);
}

export function setPath(target: DraftData, path: string, value: unknown): void {
  const keys = path.split('.');
  const last = keys.pop()!;
  let node = target as Record<string, unknown>;
  for (const key of keys) {
    node[key] ??= {};
    node = node[key] as Record<string, unknown>;
  }
  node[last] = value;
}

/** Um valor "preenchido": string não vazia, array/objeto com conteúdo. */
export function hasValue(value: unknown): boolean {
  if (value == null) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;
  return true;
}
